<template>
  <div class="console">
    <div>
      <input
        class="input-eng u-full-width"
        type="text"
        @keyup="onInput"
        @keyup.13="process"
        v-bind:value="osacian"
      />
    </div>
    <div class="outputcontianer">
      <div v-for="msg of output" v-bind:class="msg.style">
        {{msg.print}}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const __txt=document.createElement('textarea');function decodeHTML(a){return __txt.innerHTML=a,__txt.value}const alpha=['&#x53E3;','&#x25C1;','&#x25B3;','&#x25B7;','&#x25C7;','&#x3147;','&#x25BD;'],charCodes=[21475,9665,9651,9655,9671,12615,9661];function translate(a){let b='';for(var d=0;d<a.length;d++){let f=a[d];b+=charCodes.includes(f.charCodeAt(0))?f:alpha[f.charCodeAt(0)%alpha.length]}return decodeHTML(b)}const patterns={0:[{style:'success',print:translate('yesthisistheonetostartwith')},{style:'normal',print:'The computers to your left spin up for a moment.'}],2:[{style:'success',print:translate('startingtomakeprogress')}],21:[{style:'success',print:translate('justafewmorechars')}],213:[{style:'success',print:translate('wowyourereallygettingthis')}],2134:[{style:'success',print:translate('twomoretogo')}],21346:[{style:'normal',print:'You discover a map of the ship, showing that there are six escape pods on the lower deck. The Osacians are still guarding the antimatter.'},{style:'normal',print:'Make sure to mention the access code you used if you want to use this information.'}],3:[{style:'success',print:translate('startingtomakeprogress')},{style:'normal',print:'The computer beeps.'}],32:[{style:'success',print:translate('oohthisisgoingtobegood')}],321:[{style:'success',print:translate('werecookingwithgasnow')}],3213:[{style:'success',print:translate('yourereallygoodatthis')}],32132:[{style:'normal',print:'You find a screen that shows a live video feed of the Osacians guarding the antimatter. The boxes of antimatter now seem to be securely fastened to the floor.'},{style:'normal',print:'There is an option that looks like it would vent the room of air. There is another option to close and lock the doors.'},{style:'normal',print:'Make sure to note the access code if you want to use this information.'}],655:[{style:'success',print:translate('welcometotheosaciancomputer')}]};export default{data(){return{osacian:'',output:[]}},methods:{onInput(a){let b=a.target.value;this.osacian=translate(b)},process(){this.output.unshift({style:'inputtext',print:this.osacian});var a=this.osacian.split('').map(b=>b.charCodeAt(0)).map(b=>charCodes.indexOf(b)).join('');for(patterns[a]?this.output=patterns[a].concat(this.output):this.output.unshift({style:'error',print:translate('error')}),this.osacian='';10<this.output.length;)this.output.pop()}}};
/* eslint-enable */
</script>

<style scoped>
@font-face {
  font-family: invisible;
  src: url('/static/invisible1.woff') format("woff"),
      url('/static/invisible1.ttf') format("truetype");
}

.input-eng {
  margin: 0;
  padding: 1em;
  background-color: #0f0;
  color: black;
  height: 30px;
  font-family: invisible;
  border-radius: 0;
}

.input-eng:focus {
  outline-color: #0f0;
  border-color: #0f0;
}

.outputcontianer {
  white-space: break-all;
  margin-bottom: 3rem;
}

.normal {
	color: white;
	background-color: #222;
	padding: 0.5rem 0;
}

.error {
  color: red;
  background-color: #222;
  padding: 0.5rem 0;
}

.success {
  color: #0f0;
  background-color: #222;
  padding: 0.5rem 0;
}

.inputtext {
  border-bottom : 1px solid #222;
  background: #222;
  color: white;
  padding: 0.5rem 0;
}
</style>



// WEBPACK FOOTER //
// 34.min.vue?1020cd44